<template>
  <b-row align-v="center" id="request-a-demo" class="request-a-demo justify-items-sm-center">
    <b-col lg="6" md="12" cols="12">
      <h2 class="h1 text-center" v-html="$t('routes.RequestDemo')"/>
      <div id="hubspotForm" v-once />
    </b-col>
    <b-col class="image-column d-none d-lg-block" lg="6" cols="12" align="center">
      <img :src="imageSrc">
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'RequestDemo',
  mounted () {
    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '1890515',
          formId: this.formIdByRouterName,
          sfdcCampaignId: this.sfdcCampaignIdByRouterName,
          target: '#hubspotForm'
        })
      }
    })
  },
  computed: {
    sfdcCampaignIdByRouterName () {
      switch (this.$route.name) {
        case 'Complete':
          return '70113000002VbLFAA0'
        case 'LiveHrAdvice':
          return '70113000002VZmiAAG'
        case 'JobDescriptionGenerator':
          return '70113000002VZmxAAG'
        case 'Surveys':
          return '70113000002VZmnAAG'
        case 'PolicyManualWizard':
          return '70113000002VZmsAAG'
        case 'Training':
          return '70113000002GBpdAAG'
        case 'Drive':
          return '7011B0000021HtCQAU'
        case 'Fundamentals':
          return '70113000002VZmdAAG'
      }
    },
    formIdByRouterName () {
      switch (this.$route.name) {
        case 'Complete':
          return '89f73816-4dd1-4adc-9e60-105f6453ee94'
        case 'LiveHrAdvice':
          return '123f61b2-806f-44aa-a175-86b043fbd785'
        case 'JobDescriptionGenerator':
          return 'dc74ee20-d6ea-46ad-bd0e-fa40c31e5ca5'
        case 'Surveys':
          return '69ced6b7-a804-4050-aed8-8e3b80c7a476'
        case 'PolicyManualWizard':
          return 'e7d5434f-fa81-472b-9fa0-d883b9be49ff'
        case 'Training':
          return 'dc635efc-0c6e-4703-88b4-853a84ccc974'
        case 'Drive':
          return 'd7e0e202-8285-4119-b58d-3677bf29328d'
        case 'Fundamentals':
          return 'ed8ebac0-691a-4df2-abf8-da3b191ad1d9'
      }
    },
    imageSrc: app => require(`@/assets/${app.$toKebabCase(app.$route.name)}/request-a-demo.png`)
  }
}
</script>

<style lang="sass" scoped>
.request-a-demo
  margin: 200px 0

.image-column img
  max-width: 100%
</style>



// WEBPACK FOOTER //
// src/components/ui/products/RequestDemo.vue